import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { LabelModel } from 'src/app/story/models/labels/label.model';
import { Store, Select, Actions, ofActionCompleted } from '@ngxs/store';
import { QueryNodeInfo, QueryNodeInfoSuccess, QueryNodeInfoFailure, SetNodeInfo } from 'src/app/engine/state/nodes/engine.nodes.actions';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Subject, Observable } from 'rxjs';
import { EngineService } from 'src/app/engine/engine.service';
import { get } from 'lodash';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { ViewService } from 'src/app/view/view.service';
import { takeUntil } from 'rxjs/operators';
import { transition, trigger, sequence, style, animate } from '@angular/animations';

@Component({
  selector: 'app-context-label',
  templateUrl: './context-label.component.html',
  styleUrls: ['./context-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('show', [
      transition(':enter', [
        sequence([
          style({ 
            height: '0'
          }),
          animate('125ms ease-in-out', style({ 
            height: '*'
          }))
        ])
      ])
    ])
  ]
})
export class ContextLabelComponent implements OnInit, OnDestroy {
  // ---------- Observables ----------
  @Select(EngineNodesState.getSelectedNode)
  selectedNode$: Observable<ViewTreeNode>;

  @Select(EngineNodesState.getQuerying)
  querying$: Observable<boolean>;
  

  
  // ---------- Input / Output ----------
  @Input()
  set label(value: LabelModel) {
    this._label = value;
    this.setLabelNode();
  }
  get label(): LabelModel {
    return this._label;
  }

  @Input()
  enableInfo: boolean;

  @Input()
  enableActions: boolean;
  

  
  // ---------- Class Variables ----------
  allowReadMore: boolean;
  node: ViewTreeNode;

  private _label: LabelModel;
  private ngUnsubscribe = new Subject();
  
  constructor(
    private store: Store,
    private actions: Actions,
    private engineService: EngineService,
    private viewService: ViewService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }
  

  
  // ---------- Lifecycle Events ----------
  ngOnInit() {
    this.initInfoListeners();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  

  
  // ---------- Class Methods ----------
  setLabelNode() {
    const objectId = get(this.label, 'objectId');

    if (objectId) {
      const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
      this.node = this.engineService.getNode(viewGraph, objectId);

    } else {
      this.node = null;
    }
    
    this.changeDetectorRef.markForCheck();
  }

  initInfoListeners() {
    // mark "dirty" check for node updates
    this.actions
      .pipe(
        ofActionCompleted(SetNodeInfo),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(() => {
        this.setLabelNode();
      });
  }

  handleReadMoreClick() {
    if (this.node) {
      this.viewService.toggleNodeInfo(true);
    }
  }
}
